// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";

/* 路由 */
import router from "./router";

/* axios */
import axios from "./api";
import api from "./api/api";
Vue.prototype.http = axios;
Vue.prototype.api = api;

/* swiper */
import "swiper/dist/css/swiper.min.css";

/* 重置样式 */
import "./assets/css/reset.min.css";

/* jquery */
import "jquery";

/* bootstarp */
import "./assets/css/bootstrap.min.css";
import "./assets/js/bootstrap.min";

/* animate.css */
import "animate.css";

import "amfe-flexible";

import bus from "@/utils/bus";
Vue.prototype.$bus = bus;

/* 头部组件 */
import Header from "./components/Header";
Vue.component(Header.name, Header);

/* element UI*/
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);

/* 省市区选择*/
import VDistpicker from "v-distpicker";
Vue.component("v-distpicker", VDistpicker);

/* 联系我们组件 */
import ContactWe from "./components/ContactWe";
Vue.component(ContactWe.name, ContactWe);

/* 尾部组件 */
import Footer from "./components/Footer";
Vue.component(Footer.name, Footer);

/* 回到顶部 */
import GoTop from "./components/GoTop";
Vue.component(GoTop.name, GoTop);

/* s数字缓慢从0增长到指定值的插件 */
import VueAnimateNumber from "vue-animate-number";
Vue.use(VueAnimateNumber);

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    // 给每个页面浏览器名字更改
    document.title = to.meta.title;
  }
  // 路由跳转之后页面停留在上一个浏览页面位置不会回到顶部问题解决
  document.body.scrollTop = 0;
  // firefox
  document.documentElement.scrollTop = 0;
  // safari
  window.pageYOffset = 0;
  next();
});

new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js